import { render, staticRenderFns } from "./vueGoodWizard.vue?vue&type=template&id=46279824&scoped=true"
import script from "./vueGoodWizard.vue?vue&type=script&lang=js"
export * from "./vueGoodWizard.vue?vue&type=script&lang=js"
import style0 from "./vueGoodWizard.vue?vue&type=style&index=0&id=46279824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46279824",
  null
  
)

export default component.exports